"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: Date,
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    dates: {
        type: Array,
        default: undefined
    },
    depth: {
        type: String,
        default: undefined
    },
    disableDates: {
        type: [Array, Function],
        default: undefined
    },
    footer: {
        type: [String, Function],
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    month: {
        type: Object,
        default: undefined
    },
    selectable: {
        type: String,
        default: undefined
    },
    selectDates: {
        type: Array,
        default: undefined
    },
    weekNumber: {
        type: Boolean,
        default: undefined
    },
    start: {
        type: String,
        default: undefined
    },
    value: {
        type: Date,
        default: undefined
    },

    // Events
    change: Function,
    navigate: Function
};